import PropTypes from 'prop-types';

import beaconLogoFull from 'assets/BeaconLogoFull.svg';

import { ROUTES } from 'routes/route.constants';

import styles from './InviteFlow.module.scss';

const InviteFlowLayout = ({ children }) => (
  <div className={styles['page-wrapper']}>
    <div className={styles['logo-wrap']}>
      <img src={beaconLogoFull} alt="onBeacon logo" />
    </div>

    <div className={styles['page-content']}>
      {children}
    </div>

    <div className={styles['terms-wrap']}>
      <span>
        Read our
        {' '}
      </span>
      <a
        href={ROUTES.TERMS_AND_CONDITIONS}
        target="_blank"
        rel="noopener noreferrer"
      >
        Terms & Conditions
      </a>
      <span>
        {' '}
        and
        {' '}
      </span>
      <a
        href={ROUTES.PRIVACY_POLICY}
        target="_blank"
        rel="noopener noreferrer"
      >
        Privacy Policy
      </a>
    </div>
  </div>
);

InviteFlowLayout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default InviteFlowLayout;
